import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMeQuery } from '../../graphql/types';
import { isRegistrationOpen } from '../../utils/config';
import { Button } from './button';
import useActiveYear from '../../hooks/useActiveYear';

export function RegisterButton() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth0();
  const me = useMeQuery({
    fetchPolicy: 'cache-first',
  });

  const ACTIVE_YEAR = useActiveYear();

  const hasPaddle = me.data?.me?.paddle;

  const onButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (!isRegistrationOpen) {
      return;
    }
    const returnTo = `?returnTo=${encodeURIComponent(
      `${window.location.pathname}/${ACTIVE_YEAR}/lots`.replace(/^\/+/, '/')
    )}`;
    if (!isAuthenticated) {
      navigate(`/login${returnTo}`);
    } else if (!hasPaddle) {
      navigate(`/register${returnTo}`);
    } else {
      navigate(`${window.location.pathname}/${ACTIVE_YEAR}/lots`);
    }
  };

  if (isAuthenticated && hasPaddle) {
    return null;
  }

  return (
    <Button
      type="button"
      size="md"
      disabled={!isRegistrationOpen || !!hasPaddle}
      onClick={onButtonClick}
      loading={isAuthenticated && me.loading}
    >
      {!isRegistrationOpen
        ? 'Registration opening soon'
        : !isAuthenticated
        ? 'Login to bid'
        : 'Register to bid'}
    </Button>
  );
}
